"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractTicker = void 0;
class AbstractTicker {
    _disposed;
    constructor() {
        this._disposed = false;
    }
    onDispose() {
        // To be implemented by tickers
    }
    dispose() {
        this.onDispose();
        this._disposed = true;
    }
    get disposed() {
        return this._disposed;
    }
}
exports.AbstractTicker = AbstractTicker;
